module.exports = __webpack_public_path__ + "static/media/home-guarantee.a9ac98d7.png";